// Translate
import { useTrans } from "@/lib/i18n"

// Constants
import { contact } from "@/constants/constants"

// Env variables
import {
	EXTERNAL_PLATFORM_PRIVACY_POLICY,
	EXTERNAL_PLATFORM_TERMS_AND_CONDITIONS,
	EXTERNAL_PLATFORM_REWARD_POLICY,
} from "@/lib/env"

/**
 * FooterNoAuth
 * @returns
 */
export function FooterNoAuth() {
	const t = useTrans("common")

	return (
		<footer className="relative z-10 bg-primary-500">
			<div className="container mx-auto p-6 lg:px-8 lg:py-6">
				<div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
					{/* Email */}
					<div className="flex items-center gap-3">
						<span className="shrink-0">
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M17.5 3H2.5C1.4375 3 0.53125 3.875 0.53125 4.96875V15.0937C0.53125 16.1562 1.40625 17.0625 2.5 17.0625H17.5C18.5625 17.0625 19.4687 16.1875 19.4687 15.0937V4.9375C19.4687 3.875 18.5625 3 17.5 3ZM17.5 4.40625C17.5312 4.40625 17.5625 4.40625 17.5937 4.40625L10 9.28125L2.40625 4.40625C2.4375 4.40625 2.46875 4.40625 2.5 4.40625H17.5ZM17.5 15.5938H2.5C2.1875 15.5938 1.9375 15.3438 1.9375 15.0312V5.78125L9.25 10.4688C9.46875 10.625 9.71875 10.6875 9.96875 10.6875C10.2187 10.6875 10.4687 10.625 10.6875 10.4688L18 5.78125V15.0625C18.0625 15.375 17.8125 15.5938 17.5 15.5938Z"
									fill="currentColor"
								/>
							</svg>
						</span>
						<a
							href={`mailto:${contact.emailAddress}`}
							className="text-base text-black/80 transition-colors hover:text-black"
						>
							{contact.emailAddress}
						</a>
					</div>

					{/* Phone */}
					<div className="flex items-center gap-3">
						<span className="shrink-0">
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clipPath="url(#clip0_941_16343)">
									<path
										d="M15.1875 19.4688C14.3437 19.4688 13.375 19.25 12.3125 18.8438C10.1875 18 7.84374 16.375 5.74999 14.2813C3.65624 12.1875 2.03124 9.84377 1.18749 7.68752C0.249989 5.37502 0.343739 3.46877 1.43749 2.40627C1.46874 2.37502 1.53124 2.34377 1.56249 2.31252L4.18749 0.750025C4.84374 0.375025 5.68749 0.562525 6.12499 1.18752L7.96874 3.93753C8.40624 4.59378 8.21874 5.46877 7.59374 5.90627L6.46874 6.68752C7.28124 8.00002 9.59374 11.2188 13.2812 13.5313L13.9687 12.5313C14.5 11.7813 15.3437 11.5625 16.0312 12.0313L18.7812 13.875C19.4062 14.3125 19.5937 15.1563 19.2187 15.8125L17.6562 18.4375C17.625 18.5 17.5937 18.5313 17.5625 18.5625C17 19.1563 16.1875 19.4688 15.1875 19.4688ZM2.37499 3.46878C1.78124 4.12503 1.81249 5.46877 2.49999 7.18752C3.28124 9.15627 4.78124 11.3125 6.74999 13.2813C8.68749 15.2188 10.875 16.7188 12.8125 17.5C14.5 18.1875 15.8437 18.2188 16.5312 17.625L18.0312 15.0625C18.0312 15.0313 18.0312 15.0313 18.0312 15L15.2812 13.1563C15.2812 13.1563 15.2187 13.1875 15.1562 13.2813L14.4687 14.2813C14.0312 14.9063 13.1875 15.0938 12.5625 14.6875C8.62499 12.25 6.18749 8.84377 5.31249 7.46877C4.90624 6.81252 5.06249 5.96878 5.68749 5.53128L6.81249 4.75002V4.71878L4.96874 1.96877C4.96874 1.93752 4.93749 1.93752 4.90624 1.96877L2.37499 3.46878Z"
										fill="currentColor"
									/>
									<path
										d="M18.3125 8.90633C17.9375 8.90633 17.6562 8.62508 17.625 8.25008C17.375 5.09383 14.7812 2.56258 11.5937 2.34383C11.2187 2.31258 10.9062 2.00008 10.9375 1.59383C10.9687 1.21883 11.2812 0.906333 11.6875 0.937583C15.5625 1.18758 18.7187 4.25008 19.0312 8.12508C19.0625 8.50008 18.7812 8.84383 18.375 8.87508C18.375 8.90633 18.3437 8.90633 18.3125 8.90633Z"
										fill="currentColor"
									/>
									<path
										d="M15.2187 9.18755C14.875 9.18755 14.5625 8.93755 14.5312 8.56255C14.3437 6.87505 13.0312 5.56255 11.3437 5.3438C10.9687 5.31255 10.6875 4.93755 10.7187 4.56255C10.75 4.18755 11.125 3.9063 11.5 3.93755C13.8437 4.2188 15.6562 6.0313 15.9375 8.37505C15.9687 8.75005 15.7187 9.0938 15.3125 9.1563C15.25 9.18755 15.2187 9.18755 15.2187 9.18755Z"
										fill="currentColor"
									/>
								</g>
								<defs>
									<clipPath id="clip0_941_16343">
										<rect
											width="20"
											height="20"
											fill="currentColor"
										/>
									</clipPath>
								</defs>
							</svg>
						</span>
						<div className="text-center md:text-left">
							<a
								href={`tel:${contact.phoneNumber}`}
								className="text-base text-black/80 transition-colors hover:text-black"
							>
								{contact.phoneNumber}
							</a>
							<div className="text-sm text-black/60">
								{contact.phoneHours}
							</div>
						</div>
					</div>

					{/* Address */}
					<div className="flex items-center gap-3">
						<span className="shrink-0">
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M10 0.5625C5.6875 0.5625 2.1875 3.9375 2.1875 8.09375C2.1875 11.25 6.375 16.25 8.84375 18.9375C9.15625 19.2813 9.5625 19.4375 10 19.4375C10.4375 19.4375 10.8438 19.25 11.1562 18.9375C13.625 16.25 17.8125 11.25 17.8125 8.09375C17.8125 3.9375 14.3125 0.5625 10 0.5625ZM10.125 18C10.0625 18.0625 9.96875 18.0625 9.875 18C6.84375 14.6875 3.59375 10.375 3.59375 8.09375C3.59375 4.71875 6.46875 1.96875 10 1.96875C13.5312 1.96875 16.4062 4.71875 16.4062 8.09375C16.4062 10.375 13.1562 14.6875 10.125 18Z"
									fill="currentColor"
								/>
								<path
									d="M10 4.90625C8.125 4.90625 6.59375 6.4375 6.59375 8.3125C6.59375 10.1875 8.125 11.75 10 11.75C11.875 11.75 13.4062 10.2188 13.4062 8.34375C13.4062 6.46875 11.875 4.90625 10 4.90625ZM10 10.3438C8.875 10.3438 8 9.4375 8 8.34375C8 7.25 8.90625 6.34375 10 6.34375C11.0937 6.34375 12 7.25 12 8.34375C12 9.4375 11.125 10.3438 10 10.3438Z"
									fill="currentColor"
								/>
							</svg>
						</span>
						<div className="text-center text-base text-black/80 md:text-left">
							<div>{contact.officeAdress}</div>
						</div>
					</div>
				</div>
			</div>

			{/* Bottom Bar */}
			<div className="border-t border-black/10 bg-black">
				<div className="container mx-auto px-6 py-4 lg:px-8 lg:py-4">
					<div className="flex flex-col items-center justify-between gap-4 md:flex-row">
						<div className="text-center md:text-left">
							<p className="text-sm text-white/90">
								&copy; {t("common:common.brand.name")} 2025
							</p>
						</div>
						<div className="flex flex-wrap items-center justify-center gap-1 md:justify-end">
							<a
								href={EXTERNAL_PLATFORM_PRIVACY_POLICY}
								className="px-4 py-2 text-sm text-white/80 transition-colors hover:text-primary-500"
							>
								{t("common.footer.privacy_policy")}
							</a>
							<span className="hidden text-white/40 md:inline">
								•
							</span>
							<a
								href={EXTERNAL_PLATFORM_TERMS_AND_CONDITIONS}
								className="px-4 py-2 text-sm text-white/80 transition-colors hover:text-primary-500"
							>
								{t("common.footer.terms_conditions")}
							</a>
							<span className="hidden text-white/40 md:inline">
								•
							</span>
							<a
								href={EXTERNAL_PLATFORM_REWARD_POLICY}
								className="px-4 py-2 text-sm text-white/80 transition-colors hover:text-primary-500"
							>
								{t("common.footer.policy")}
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	)
}
